import { DocumentUserAssignment } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationAssignments = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
): Promise<NonPaginatedResponse<DocumentUserAssignment[]> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/assignments`, {
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
